import React from 'react';
import {MainLayout} from 'components/layouts';
import FairDetail from 'components/fair/FairDetail.jsx';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';

class DetailFair extends React.Component {
  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fairs`}><i className='fa fa-chevron-left' />Quay về trang danh sách</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Chi tiết hội chợ</h1>
          </div>
          <FairDetail match={this.props.match}/>
        </div>
      </MainLayout>
    );
  }
}

DetailFair.contextTypes = {
  router: React.PropTypes.object
};

export default connect()(DetailFair);


// WEBPACK FOOTER //
// ./pages/fair/Detail.jsx